import { ref,computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import debounce from '../../foundation/js/deBounce'

import {dataLayerAddToCart} from '../../foundation/js/dataLayerHelpers'

const floorToColliMatch = function(colli,currentAmount){
    const isColliMatch = !(currentAmount % colli)
    return isColliMatch ? currentAmount : currentAmount - (currentAmount % colli)
}


export default {
    name: "CartButton",
    props: {
        collisize: {
            default: 2
        },
        productid: {
            required: true
        },
        variantsku: {
            required: true
        },
        isParentComponentBasket: {
            required: true
        },
        quantity: {
            required: false //only relevant for cart/basket page
        },
        productData: {
            required: false
        }
    },
    setup(props){
        const store = useStore()
        const amount = ref(props.collisize)
        const savedAmount = ref(0)
        const cartOperationStatus = ref(null)
        const addToCartDisabled = computed(() => store.state.main.add_to_cart_disabled)
        const addToCartDisabledMessage = computed(() => store.state.main.add_to_cart_disabled_message)
        
        const dataForDataLayer = function(quantity){
            const statisticsdata = props.productData || {}
            statisticsdata.quantity = quantity
            return statisticsdata
        }

        onMounted(()=>{
            amount.value = props.quantity ? props.quantity : props.collisize
        })

        watch(
            ()=>props.quantity,
            (quantity)=>{
                amount.value = quantity
            })

        const handleCartSpinner = function(statusCode){
            const inert = 0
            const showSpinner = 1
            const success = 2
            const failure = 3

            cartOperationStatus.value = statusCode

            if(statusCode === success || statusCode === failure){
                setTimeout(()=>{
                    cartOperationStatus.value = inert
                },1500)
            }
        }

        const increaseAmount = function(){
            const amountToIncrease = floorToColliMatch(props.collisize,amount.value)
            amount.value = +amountToIncrease + +props.collisize

            if (props.isParentComponentBasket) {
                updateCart(amount.value)
            }
        }

        const decreaseAmount = function(){
            
            const setAmount = () => {
                const decreasedAmount = (amount.value - props.collisize) > props.collisize ? (amount.value - props.collisize) : props.collisize
                const flooredAmount = floorToColliMatch(props.collisize,decreasedAmount)
                amount.value = flooredAmount !== decreasedAmount ? +flooredAmount+ +props.collisize : +flooredAmount
            }

            if (props.isParentComponentBasket) {
                if ((amount.value - props.collisize) > 0) {
                    setAmount()
                    updateCart(amount.value)
                } else {
                    removeFromCart()
                }
            } else {
                setAmount()
            }
            
        }

        const clearField = function(e){
            savedAmount.value = amount.value
            amount.value = ''
        }

        const updateField = function(){

            const setAmount = () => {
                const newAmount = (amount.value && savedAmount.value !== amount.value) ? +amount.value : savedAmount.value
                amount.value = newAmount ? +newAmount : +props.collisize           
            }

            if (props.isParentComponentBasket) {
                if (amount.value <= 0) {
                    removeFromCart()
                } else {
                    setAmount()
                    const isValueADecimalNumber = amount.value % 1 != 0
                    if (isValueADecimalNumber) amount.value = +props.collisize
                    updateCart(amount.value)
                }
            } else {
                setAmount()
            }
        }

        const addToCart = debounce(function(){
            if (addToCartDisabled.value) return
            handleCartSpinner(1)
            dataLayerAddToCart(dataForDataLayer(amount.value))
            store.dispatch('ecom/addToCart',{
                productSku: props.productid,
                variantSku: props.variantsku,
                quantity: amount.value
            }).then(status => handleCartSpinner(status ? 2 : 3))
        }, 400)

        const removeFromCart = function(){
            store.dispatch('ecom/removeItemFromOrderline',{
                productSku: props.productid,
                variantSku: props.variantsku,
            })
        }

        const updateCart = debounce(function(quantity) {
            handleCartSpinner(1)
            store.dispatch('ecom/updateProductInCart',{
                productSku: props.productid,
                variantSku: props.variantsku,
                quantity: quantity
            }).then(status => handleCartSpinner(status ? 2 : 3))
        }, 400)


        return {
            amount,
            increaseAmount,
            decreaseAmount,
            clearField,
            updateField,
            addToCart,
            removeFromCart,
            cartOperationStatus,
            addToCartDisabled,
            addToCartDisabledMessage
        }
        
    }
}
